// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import TeamOutlined from '/Users/yunfei/workspace-tuku/tuku-cms-bo/node_modules/@ant-design/icons/es/icons/TeamOutlined';
import FileTextOutlined from '/Users/yunfei/workspace-tuku/tuku-cms-bo/node_modules/@ant-design/icons/es/icons/FileTextOutlined';
import MessageOutlined from '/Users/yunfei/workspace-tuku/tuku-cms-bo/node_modules/@ant-design/icons/es/icons/MessageOutlined';
import SettingOutlined from '/Users/yunfei/workspace-tuku/tuku-cms-bo/node_modules/@ant-design/icons/es/icons/SettingOutlined';
import UserOutlined from '/Users/yunfei/workspace-tuku/tuku-cms-bo/node_modules/@ant-design/icons/es/icons/UserOutlined';
export default { TeamOutlined, FileTextOutlined, MessageOutlined, SettingOutlined, UserOutlined };
